<template>
    <div>
        <div class="row border-bottom">
            <div class="col-12">
                <div class="mb-2 float-right">
                    <div class="row">
                        <div class="col-xs-offset 1 col-xs-11 col-sm-offset-2 col-sm-8 col-md-offset-3 col-md-6">
                            <div class="btn-toolbar" role="toolbar">
                                <div class="btn-group btn-group-justified" role="group">
                                    <div class="btn-group" role="group">
                                        <button id="refresh" class="btn btn-primary" data-original-title="Refresh" @click="getClaimPaymentsForClaim(claimId)"><i class="fas fa-sync-alt" aria-hidden="true"></i></button>
                                    </div>
                                    <div class="btn-group" role="group">
                                        <button id="new" class="btn btn-primary" data-original-title="New" :disabled="isReadonly" @click="handleNewClick(claimId)"><i class="fas fas fa-plus" aria-hidden="true"></i></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="loading && loading == true" class="row align-items-center justify-content-center">
            <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
        <table v-else class="table">
            <thead>
                <tr>
                    <th scope="col">Gadget</th>
                    <th scope="col">Payment Type</th>
                    <th scope="col">Payee Type</th>
                    <th scope="col">Provider</th>
                    <th scope="col">Transaction Type</th>
                    <th scope="col">Currency</th>
                    <th scope="col">Net</th>
                    <th scope="col">Tax</th>
                    <th scope="col">Gross</th>
                    <th scope="col">Date</th>
                    <th scope="col">Authorised Date</th>
                    <th scope="col">Authorised By</th>
                    <th scope="col">Actions</th>
                </tr>
            </thead>
            <tbody>
                <!-- :class="itm.transactionTypeId == 1 ? 'bg-danger' : 'bg-success'" -->
                <tr v-for="(itm, idx) in claimPayments" :key="'claimpaymentlist_' + idx"
                    :class="selectedRowIndex == idx ? 'table-primary' : ''"
                    :style="'cursor: pointer'"
                    @click="handleRowClick(idx, itm)">
                    <td>{{itm.gadgetDisplayLabel}}</td>
                    <td>{{itm.claimPaymentTypeLabel}}</td>
                    <td>{{itm.payeeTypeLabel}}</td>
                    <td>{{itm.settlementOptionProviderLabel}}</td>
                    <td>{{itm.transactionTypeLabel}}</td>
                    <td>{{itm.currencyCode}}</td>
                    <td>{{parseFloat(itm.net).toFixed(2)}}</td>
                    <td>{{parseFloat(itm.tax).toFixed(2)}}</td>
                    <td>{{parseFloat(itm.gross).toFixed(2)}}</td>
                    <td>{{localeString(itm.dateCreated)}}</td>
                    <td>{{localeString(itm.authorisedDate)}}</td>
                    <td>{{itm.authorisedByLabel}}</td>
                    <td>
                        <b-dropdown size="lg" variant="link" toggle-class="text-decoration-none" no-caret :boundary="'window'">
                            <template v-slot:button-content>
                                <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                                <span class="sr-only">Actions menu</span>
                            </template>
                            <b-dropdown-item href="javascript:void(0)" @click="handleEditClick(idx,itm)" :disabled="isReadonly">
                                <i v-if="false" :class="iconClass"></i> Edit
                            </b-dropdown-item>
                            <b-dropdown-item href="javascript:void(0)" @click="handleDeleteClick(idx,itm)" :disabled="isReadonly">
                                <i v-if="false" :class="iconClass"></i> Delete
                            </b-dropdown-item>
                            <b-dropdown-divider></b-dropdown-divider>
                            <b-dropdown-item href="javascript:void(0)" @click="handleAuthoriseClick(idx,itm)" :disabled="!canAuthorise(idx,itm)">
                                <i v-if="false" :class="iconClass"></i> Authorise
                            </b-dropdown-item>
                            <!--<b-dropdown-item href="javascript:void(0)" @click="handleCreateClaimPaymentClick(idx,itm)" :disabled="itm.claimPaymentId > 0">
                            <i v-if="false" :class="iconClass"></i> Create Claim Payment
                        </b-dropdown-item>-->
                        </b-dropdown>
                    </td>
                </tr>
            </tbody>
        </table>
        <b-modal :id="'claim-payment-new-modal-' + $vnode.key" title="Claim Payment" size="lg" hide-footer>
            <div >
                <b-list-group>
                    <b-list-group-item button :active="newPaymentType == 8" @click="newPaymentType = 8">Compensation - Claimant</b-list-group-item>
                    <b-list-group-item button disabled>FOS fee</b-list-group-item>
                    <b-list-group-item button disabled>Cash settlement  - accessories</b-list-group-item>
                    <b-list-group-item button disabled>Reimbursement</b-list-group-item>
                </b-list-group>
                <div v-if="newPaymentType== null" class="float-right">
                    <button type="button" class="btn btn-secondary">Close</button>
                </div>
            </div>
            <div v-if="newPaymentType == 8">
                <hr />
                <div class="row">
                    <div class="col-5 pl-4 p-2">
                        <span>Amount</span>
                    </div>
                    <div class="col-4 border-left pl-4 p-2">
                        <input type="text" class="form-control" id="claimPaymentGross" v-model="editAmountModel.gross">
                        <div style="width: 100%; margin-top: 0.25rem; font-size: 80%; color: #dc3545;" v-show="!editAmountModel.validators.find(v => v.item == 'gross').isValid">

                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-5 pl-4 p-2">
                        <span>Reference</span>
                    </div>
                    <div class="col-4 border-left pl-4 p-2">
                        <input type="text" class="form-control">
                        <div style="width: 100%; margin-top: 0.25rem; font-size: 80%; color: #dc3545;" v-show="!editAmountModel.validators.find(v => v.item == 'gross').isValid">

                        </div>
                    </div>
                </div>
                    <div class="row">
                        <div class="col-5 pl-4 p-2">
                            <span>Reason</span>
                        </div>
                        <div class="col-4 border-left pl-4 p-2">
                            <!-- :class="selectedDocumentSubtype == null ? 'border-danger' : 'border-success'" -->
                            <select class="form-control mt-2">
                                <option value="null">
                                    SELECT...
                                </option>
                                <option value="1">
                                    Complaint
                                </option>
                                <option value="1">
                                    Other
                                </option>
                            </select>
                        </div>
                        
                        </div>
                        <hr />
                        <div class="float-right">
                            <button type="button" class="btn btn-secondary">Close</button>
                            <button type="button" class="btn btn-primary ml-2">OK</button>
                        </div>
                    </div>
            
        </b-modal>
        <b-modal :id="'claim-payment-edit-modal-' + $vnode.key" title="Claim Payment" size="lg" hide-footer>
            <div v-if="selectedItem">
                <div class="row mt-2">
                    <div class="col pl-4 p-2">
                        <span>Gadget</span>
                    </div>
                    <div class="col-7 border-left pl-4 p-2">
                        <span>{{selectedItem.gadgetDisplayLabel}}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col pl-4 p-2">
                        <span>Payment Type</span>
                    </div>
                    <div class="col-7 border-left pl-4 p-2">
                        <span>{{selectedItem.claimPaymentTypeLabel}}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col pl-4 p-2">
                        <span>Payee Type</span>
                    </div>
                    <div class="col-7 border-left pl-4 p-2">
                        <span>{{selectedItem.payeeTypeLabel}}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col pl-4 p-2">
                        <span>Provider</span>
                    </div>
                    <div class="col-7 border-left pl-4 p-2">
                        <span>{{selectedItem.settlementOptionProviderLabel}}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col pl-4 p-2">
                        <span>Transaction Type</span>
                    </div>
                    <div class="col-7 border-left pl-4 p-2">
                        <span>{{selectedItem.transactionTypeLabel}}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col pl-4 p-2">
                        <span>Currency</span>
                    </div>
                    <div class="col-7 border-left pl-4 p-2">
                        <span>{{selectedItem.currencyCode}}</span>
                    </div>
                </div>
                <hr />
                <div class="row">
                    <div class="col-5 pl-4 p-2">
                        <span>Net</span>
                    </div>
                    <div class="col-4 border-left pl-4 p-2">
                        <input type="text" class="form-control" id="claimPaymentNet" v-model="editAmountModel.net">
                        <div style="width: 100%; margin-top: 0.25rem; font-size: 80%; color: #dc3545;" v-show="!editAmountModel.validators.find(v => v.item == 'net').isValid">
                            {{editAmountModel.validators.find(v => v.item == 'net').inValidFeedback}}
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-5 pl-4 p-2">
                        <span>Tax</span>
                    </div>
                    <div class="col-4 border-left pl-4 p-2">
                        <input type="text" class="form-control" id="claimPaymentTax" v-model="editAmountModel.tax">
                        <div style="width: 100%; margin-top: 0.25rem; font-size: 80%; color: #dc3545;" v-show="!editAmountModel.validators.find(v => v.item == 'tax').isValid">
                            {{editAmountModel.validators.find(v => v.item == 'tax').inValidFeedback}}
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-5 pl-4 p-2">
                        <span>Gross</span>
                    </div>
                    <div class="col-4 border-left pl-4 p-2">
                        <input type="text" class="form-control" id="claimPaymentGross" v-model="editAmountModel.gross">
                        <div style="width: 100%; margin-top: 0.25rem; font-size: 80%; color: #dc3545;" v-show="!editAmountModel.validators.find(v => v.item == 'gross').isValid">
                            {{editAmountModel.validators.find(v => v.item == 'gross').inValidFeedback}}
                        </div>
                        <div v-if="isOverCoverLimit(editAmountModel.gross,gadget)" class="invalid-feedback d-block">
                            Amount is over cover limit, please check!
                        </div>
                    </div>
                </div>
                <hr />
                <div class="float-right">
                    <button type="button" class="btn btn-secondary" :disabled="loading" @click="handleCloseClick()">Close</button>
                    <button type="button" class="btn btn-primary ml-2" :disabled="!editAmountModelIsValid() || loading" @click="handleOKClick()">OK</button>
                </div>
            </div>
            </b-modal>
    </div>
</template>
<script>
    import { mapActions, mapGetters } from 'vuex'

    import axios from 'axios'
    import { API_BASE_URL } from '../globalVar'

    import { required, numeric, numericDecimal, minLen } from '@/util/validators'
    import { runValidators, getValidators, getValidatorsIsValid } from '@/util/validation'

    import watchAll from '@/mixins/watchAll.js'
    import validator from '@/mixins/validator.js'
    import coverLimitHelper from '../mixins/coverLimitHelper'

    export default {
        name: 'ClaimPayments',
        props: {
            claimId: {
                type: Number,
                required: true
            },
            load: Boolean
        },
        mixins: [
            watchAll,
            validator,
            coverLimitHelper
        ],
        components: {},
        data: () => {
            return {
                baseUrl: API_BASE_URL,
                claimPayments: [],
                selectedRowIndex: null,
                selectedItem: null,

                editAmountModel: {
                    net: 0,
                    tax: 0,
                    gross: 0,
                    validators: [
                        {
                            item: 'net',
                            validators: [
                                numericDecimal
                            ],
                            isValid: false,
                            inValidFeedback: 'Numeric'
                        },
                        {
                            item: 'tax',
                            validators: [
                                numericDecimal
                            ],
                            isValid: false,
                            inValidFeedback: 'Numeric'
                        },
                        {
                            item: 'gross',
                            validators: [
                                required,
                                numericDecimal
                            ],
                            isValid: false,
                            inValidFeedback: 'Required, Numeric'
                        }
                    ]
                },
                loading: false,
                newPaymentType: null
            }
        },
        watch: {
            load: async function (newVal, oldVal) {
                if (newVal == true) {
                    await this.getClaimPaymentsForClaim(this.claimId)
                }
            }
        },
        computed: {
            isReadonly() {
                return this.$adminUser.isReadonly();
            },
            gadget() {
                if (this.selectedItem) {
                    return { id: this.selectedItem.gadgetId }
                }
                return null
            }
        },
        methods: {
            ...mapActions({
                authorise: 'claimPayments/authorise',
                raiseToastMsg: 'notificationModule/toast',
                fetchGadgets: 'fetchGadgetsForClaim'
            }),
            async getClaimPaymentsForClaim(claimId) {
                //console.log('PING2')
                if (claimId && !isNaN(claimId)) {
                    //console.log('PING3')
                    this.loading = true
                    try {
                        const response = await axios.get('/api/admin/v1/finance/claimpayments/' + claimId)
                        //console.log("-r : ", response)
                        const { data } = response
                        this.claimPayments = data
                    } catch (error) {
                        console.error(error)
                    } finally {
                        this.loading = false
                        this.$emit('finished-loading')
                    }
                }
            },
            handleRowClick(rowIndex, item) {
                this.selectedRowIndex = rowIndex
            },
            handleEditClick(rowIndex, item) {
                this.selectedItem = item
                this.editAmountModel.net = parseFloat(item.net).toFixed(2)
                this.editAmountModel.tax = parseFloat(item.tax).toFixed(2)
                this.editAmountModel.gross = parseFloat(item.gross).toFixed(2)
                this.$bvModal.show('claim-payment-edit-modal-' + this.$vnode.key)
            },
            handleNewClick() {
                this.newPaymentType = null
                this.$bvModal.show('claim-payment-new-modal-' + this.$vnode.key)
            },
            async handleDeleteClick(rowIndex, item) {
                this.selectedItem = item

                const confirm = await this.$bvModal.msgBoxConfirm('Please confirm you want to Delete this payment?')
                if (confirm != null) {
                    console.log('-c : ', confirm)
                    if (confirm == true) {
                        let { id, rv } = this.selectedItem
                        let payload = {
                            claimPaymentId: id,
                            rv: rv
                        }
                        //console.log('-p : ', payload)

                        this.loading = true
                        try {
                            const response = await axios.post('/api/admin/v1/finance/deleteclaimpayment/', payload)
                            //console.log("-r : ", response)
                            const { data } = response
                            if (data) {
                                this.claimPayments = this.claimPayments.filter(i => i.id !== data.id)
                            }

                        } catch (error) {
                            console.error(error)
                        } finally { this.loading = false }
                    }
                }
            },
            async handleAuthoriseClick(rowIndex, item) {
                if (!this.canAuthorise(rowIndex, item)) {
                    let { gross } = item
                    this.raiseToastMsg(`Document cannot be approved because amount £${gross} is greater than your payment limit £${this.$adminUser.getPaymentApprovalLimit()}`)
                } else {
                    this.selectedItem = item
                    const confirm = await this.$bvModal.msgBoxConfirm('Please confirm you want to Authorise this payment?')
                    if (confirm != null) {
                        console.log('-c : ', confirm)
                        if (confirm == true) {
                            let { id, rv } = this.selectedItem
                            let payload = {
                                claimPaymentId: id,
                                rv: rv
                            }
                            console.log('-p : ', payload)

                            this.loading = true
                            try {
                                const response = await this.authorise(payload)
                                console.log("-r : ", response)
                                const { data } = response
                                //if (data) {
                                //    this.claimPayments = this.claimPayments.filter(i => i.id !== data.id)
                                //}

                            } catch (error) {
                                console.error(error)
                            } finally { this.loading = false }
                        }
                    }
                }
            },
            canAuthorise(rowIndex, item) {
                if (this.isReadonly)
                    return false;

                let { authorised, claimPaymentTypeId, transactionTypeId, gross } = item

                //console.log('claimPaymentTypeId: ', claimPaymentTypeId)
                //console.log('gross: ', gross)
                //console.log('this.$adminUser.getPaymentApprovalLimit(): ', this.$adminUser.getPaymentApprovalLimit())
                //console.log('(claimPaymentTypeId == 1 || claimPaymentTypeId == 2): ', (claimPaymentTypeId == 1 || claimPaymentTypeId == 2))
                if (gross > 0) {
                    if (authorised === false && (claimPaymentTypeId == 1 || claimPaymentTypeId == 2) && transactionTypeId == 2) {
                        if (gross && this.$adminUser.getPaymentApprovalLimit() > gross) {
                            //console.log(true)
                            return true;
                        }
                    }
                }
                console.log(false)
                return false;
            },
            editAmountModelRunValidators() { runValidators(this.editAmountModel) },
            editAmountModelIsValid() { return getValidatorsIsValid(this.editAmountModel) },
            async handleOKClick() {
                let { net, tax, gross } = this.editAmountModel

                if (gross && this.$adminUser.getPaymentApprovalLimit() < gross) {
                    this.raiseToastMsg(`Document cannot be approved because amount £${gross} is greater than your payment limit £${this.$adminUser.getPaymentApprovalLimit()}`)
                } else {
                    let { id, rv } = this.selectedItem
                    let payload = {
                        claimPaymentId: id,
                        net: parseFloat(net).toFixed(2),
                        tax: parseFloat(tax).toFixed(2),
                        gross: parseFloat(gross).toFixed(2),
                        rv: rv
                    }
                    //console.log('-p : ', payload)
                    this.loading = true
                    try {
                        const response = await axios.post('/api/admin/v1/finance/updateclaimpaymentamounts/', payload)
                        //console.log("-r : ", response)
                        const { data } = response
                        if (data) {
                            this.claimPayments = this.claimPayments.map(i => i.id !== data.id ? i : data)
                            this.$bvModal.hide('claim-payment-edit-modal-' + this.$vnode.key)
                        }

                    } catch (error) {
                        console.error(error)
                    } finally { this.loading = false }
                }
            },
            async handleCreateClaimPaymentClick(idx, itm) {
                this.loading = true
                try {

                } catch (error) {
                    console.error(error)
                } finally { this.loading = false }
            },
            handleCloseClick() {
                this.$bvModal.hide('claim-payment-edit-modal-' + this.$vnode.key)
                this.selectedItem = null
                this.editAmountModel.net = 0
                this.editAmountModel.tax = 0
                this.editAmountModel.gross = 0
            },
            localeString(val) {
                if (val != null) {
                    var dte = new Date(val)
                    if (typeof dte.getMonth === 'function' && !isNaN(dte.getMonth()))
                        return dte.toLocaleString('en-GB', { timeZone: 'Europe/London' })
                }

                return null
            },
            localeDateString(val) {
                var dte = new Date(val)
                if (typeof dte.getMonth === 'function' && !isNaN(dte.getMonth()))
                    return dte.toLocaleDateString('en-GB')

                return null
            },
            loadGadgetDetails() {
                if (this.selectedClaim) {
                    if (!this.selectedClaim.gadgetDetails || this.selectedClaim.gadgetDetails.length == 0) {
                        this.fetchGadgets(this.selectedClaim.claimId)
                    }
                }
            }
        },
        async beforeMount() {
            this.loadGadgetDetails()
        },
        async mounted() {

            this.watchAll(['editAmountModel.net', 'editAmountModel.tax', 'editAmountModel.gross'],
                this.editAmountModelRunValidators.bind(this))

        }
    }
</script>